<ion-text
  *ngIf="data.solved"
  [innerHTML]="translationKey+'.win_dialog.text' | translate:{ duration: duration, guessCount: data.guessCount, maxGuesses: data.maxGuesses }"
></ion-text>

<ion-text
  *ngIf="!data.solved"
  [innerHTML]="translationKey+'.win_dialog.text_lost' | translate:{ maxGuesses: data.maxGuesses }"
></ion-text>

<div class="word-guess-win-solution">
  <ion-text><p>{{ translationKey+'.win_dialog.solution_message' | translate }}</p></ion-text>
  <p class="word-guess-win-solution-word">{{ displaySolution }}</p>
</div>
